export default {
  GET_CLEARANCE_BY_GROUP: 'getClearanceByGroup',
  GET_USER_GROUPS_CLEARANCES: 'getUserGroupsClearances',
  SAVE_SECURITY_CLEARANCE: 'saveSecurityClearance'
}
